import * as PIXI from 'pixi.js';
import { defaultVertex, Filter, RenderTexture, systems } from 'pixi.js';
import { Resolution } from '../../../../shared/constants';
import { Colors } from '../../palettes/colorPalette';
import membraneDeferredLighting from '../shaders/fragment/membraneDeferredLighting';

export class MembraneFilter extends Filter {

	scaleFactor = 1.0;

	constructor(private membraneBuffer: PIXI.RenderTexture) {
		super(defaultVertex, membraneDeferredLighting);
	}

	/**
	 * Override existing apply method in PIXI.Filter
	 * @private
	 */
	apply(filterManager: systems.FilterSystem, input: RenderTexture, output: RenderTexture, clear: boolean, currentState?: any) {

		this.uniforms.texelSize = [(1 / Resolution.Width) * this.scaleFactor, 1 / (Resolution.Height) * this.scaleFactor];
		this.uniforms.depthTexture = this.membraneBuffer;

		this.uniforms.uMembraneColor = PIXI.utils.hex2rgb(Colors.MembraneColor);
		this.uniforms.uMembraneAlpha = Colors.MembraneAlpha;

		this.uniforms.uAlternateMembraneColor = PIXI.utils.hex2rgb(Colors.AlternateMembraneColor);
		this.uniforms.uAlternateMembraneAlpha = Colors.AlternateMembraneAlpha;

		filterManager.applyFilter(this, input, output, clear);
	}
}